import { useRouter } from '@sls-react/routing';
import { useMemo } from 'react';
import qsParse from '@sls-react/utils/qsParse';
import { ParsedUrlQuery } from 'querystring';

/**
 * Gets the router's asPath query into a typed object.
 */
export default function useBrowserRouteQuery<Q extends ParsedUrlQuery>() {
  const router = useRouter();
  return useMemo(() => qsParse<Q>(router.asPath?.split('?')[1]), [
    router.asPath,
  ]);
}
